import Tickets from "@/pages/Tickets";
// Staff queue reuses ticket list with scope=all as default
export default function StaffQueue() {
  return <Tickets />;
}
